<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <p class="title">Clubes</p>
      </div>
    </section>

    <!-- Create Club Button -->
    <div class="columns">
      <div class="column is-2">
        <b-button
          icon-left="plus"
          icon-pack="fas"
          type="is-success"
          @click="openModalCreate"
          expanded
        >
          Crear Club
        </b-button>
      </div>
    </div>

    <!-- Table -->
    <b-table
      :data="clubs"
      :paginated="isPaginated"
      :per-page="perPage"
      @page-change="onPageChange"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :bordered="isBordered"
      :striped="true"
      :narrowed="isNarrowed"
      :hoverable="true"
      :loading="loadingTableList"
      :focusable="isFocusable"
      :mobile-cards="hasMobileCards"
      :detailed="false"
    >
      <b-table-column field="Nombre" label="Nombre" sortable v-slot="props">
        {{ props.row.Nombre }}
      </b-table-column>

      <!-- <b-table-column field="UrlLogin" label="UrlLogin" v-slot="props">
        <a
          :href="props.row.UrlLogin"
          target="_blank"
          v-if="props.row.UrlLogin"
          >{{ props.row.UrlLogin }}</a
        >
        <span v-else>-</span>
      </b-table-column>

      <b-table-column field="UrlWeek" label="UrlWeek" v-slot="props">
        <a :href="props.row.UrlWeek" target="_blank" v-if="props.row.UrlWeek">{{
          props.row.UrlWeek
        }}</a>
        <span v-else>-</span>
      </b-table-column> -->

      <b-table-column field="IdTC" label="IdTC" sortable v-slot="props">
        {{ props.row.IdTC }}
      </b-table-column>

      <b-table-column label="Acciones" centered v-slot="props">
        <b-tooltip label="Editar" type="is-info">
          <b-button
            type="is-info is-light"
            icon-left="eye"
            icon-pack="fas"
            size="is-small"
            @click="openModalEdit(props.row)"
          ></b-button>
        </b-tooltip>
      </b-table-column>

      <template #empty>
        <div class="has-text-centered">No hay clubes registrados</div>
      </template>
    </b-table>

    <!-- Modal -->
    <b-modal
      v-model="isModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      width="960"
    >
      <template #default="props">
        <modal-create-club
          :clubToEdit="selectedClub"
          @close="props.close"
          @refresh="loadClubs"
        ></modal-create-club>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import ModalCreateClub from "./ModalCreateClub.vue";

const API_URL = process.env.VUE_APP_API_URL;

export default {
  name: "Clubs",
  components: {
    ModalCreateClub,
  },
  data() {
    return {
      clubs: [],
      isModalActive: false,
      selectedClub: null,

      // Table props
      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 10,
      isBordered: false,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,
      loadingTableList: false,
    };
  },
  created() {
    this.loadClubs();
  },
  methods: {
    async loadClubs() {
      this.loadingTableList = true;
      try {
        const { data } = await axios.get(`${API_URL}/system/club/list`);
        // Handle various response data shapes securely
        if (Array.isArray(data)) {
          this.clubs = data;
        } else if (data && Array.isArray(data.clubs)) {
          this.clubs = data.clubs;
        } else if (data && Array.isArray(data.data)) {
          this.clubs = data.data;
        } else {
          this.clubs = [];
        }
      } catch (error) {
        console.error("Error loading clubs:", error);
        this.$buefy.toast.open({
          message: "Error al cargar la lista de clubes",
          type: "is-danger",
        });
      } finally {
        this.loadingTableList = false;
      }
    },
    openModalCreate() {
      this.selectedClub = null;
      this.isModalActive = true;
    },
    openModalEdit(club) {
      this.selectedClub = club;
      this.isModalActive = true;
    },
    onPageChange(page) {
      this.currentPage = page;
    },
  },
};
</script>
